import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const Dashboard = React.lazy(() => import("./Dashboard"));

// Post-payment learner hub. Permissions resolved from backend dashboard/permissions.ts
// (view = DASHBOARD_VIEW / LM_STUDENT / ADMIN — every paid learner reaches it).
const dashboardModuleConfig: ModuleConfig = {
  id: "dashboard",
  name: "Dashboard",
  description: "Your surgical-preparation home — surgery countdown, to-dos, and quick access to your course.",
  version: "0.0.1",
  enabled: true,
  category: "education",
  order: 1,
  icon: "🏠",
  color: "#3B82F6",

  routes: [
    {
      path: "/dashboard",
      component: Dashboard,
      permissionLevel: "view",
      useLayout: true,
      layoutOptions: { maxW: "container.lg" },
    },
  ],

  navigation: [
    {
      label: "Dashboard",
      path: "/dashboard",
      icon: "🏠",
      permissionLevel: "view",
    },
  ],

  // Resolved from backend dashboard/permissions.ts — empty arrays (backend is SoT).
  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },

  quickActions: [
    {
      label: "My Dashboard",
      path: "/dashboard",
      icon: "🏠",
      description: "Your surgery countdown, to-dos, and course access",
    },
  ],
};

export default dashboardModuleConfig;
